export default __webpack_public_path__ + "static/media/Spinner_White.3b0d6cca.svg";